import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/icons/checked.svg'
import _imports_1 from '@/assets/icons/pencil.svg'


const _hoisted_1 = ["id"]
const _hoisted_2 = {
  class: "step-flow-header",
  title: "Selecione todos os campos para avançar!"
}
const _hoisted_3 = { class: "step-flow-title" }
const _hoisted_4 = {
  key: 0,
  src: _imports_0,
  alt: "OK"
}
const _hoisted_5 = {
  key: 0,
  class: "fas fa-chevron-up"
}
const _hoisted_6 = {
  key: 1,
  class: "fas fa-chevron-down"
}
const _hoisted_7 = {
  key: 0,
  class: "step-flow-content"
}
const _hoisted_8 = { class: "step-flow-content-slot" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "Editar"
}, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, "Editar", -1)
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]

type ObStepFlowPropsT = { elementId: string; isSelected?: boolean; isDisabled?: boolean; disableEdit?: boolean };

export default /*#__PURE__*/_defineComponent({
  props: {
    elementId: null,
    isSelected: { type: Boolean, default: false },
    isDisabled: { type: Boolean, default: false },
    disableEdit: { type: Boolean, default: false }
  },
  emits: ["click:edit"],
  setup(__props: any, { emit }) {

const props = __props as { elementId: string, isSelected: boolean, isDisabled: boolean, disableEdit: boolean }




function handleEditClick() {
  if (props.isDisabled) return;
  emit("click:edit");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['step-flow', { 'is-disabled': __props.isDisabled }]),
    id: __props.elementId
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, [
        _renderSlot(_ctx.$slots, "title"),
        (!__props.isDisabled && !__props.isSelected)
          ? (_openBlock(), _createElementBlock("img", _hoisted_4))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("span", {
        class: "step-flow-icon",
        onClick: handleEditClick
      }, [
        (__props.isSelected)
          ? (_openBlock(), _createElementBlock("i", _hoisted_5))
          : (_openBlock(), _createElementBlock("i", _hoisted_6))
      ])
    ]),
    (!__props.isDisabled && !__props.isSelected)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("span", _hoisted_8, [
            _renderSlot(_ctx.$slots, "default")
          ]),
          (!__props.disableEdit)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "button",
                onClick: handleEditClick
              }, _hoisted_11))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}
}

})